import {Axios} from 'axios'

export class Api extends Axios {
  constructor() {
    super({
      baseURL: 'https://cockpit.club-der-100.de' + '/api',
      headers: {},
    });
    this.url = 'https://cockpit.club-der-100.de';
    this.setupWrappers();
  }

  setupWrappers() {
    // Collection wrapper
    this.collection = {
      get: (id) => {
        return this.get('/collections/get/' + id);
      }
    };

    // Singleton wrapper
    this.singleton = {
      get: (id) => {
        return this.get('/singletons/get/' + id);
      }
    };
  }
}

class RefectPromise {
  constructor(rejectMessage) {
    return new Promise((resolve, reject) => {
      reject(rejectMessage);
    });
  }
}



// WEBPACK FOOTER //
// ./src/components/api/index.js